import { createSelector } from "@reduxjs/toolkit";

export const getDocumentTextUndoManager = createSelector(
  (state) => state.documentData.undoManager,
  (a) => a
);

export const externalIconSelector = createSelector(
  (state) => state.documentData.externalIcons,
  (a) => a
);

export const documentsDataSelector = createSelector(
  (state) => state.documentData,
  (a) => a
);

export const oldDocumentDataSelector = createSelector(
  (state) => state.documentData.oldDocument,
  (a) => a
);


export const productLookupDataSelector = createSelector(
  (state) => state.documentData.productLookup,
  (a) => a
);

export const contactsSelectSearchDataSelector = createSelector(
  (state) => state.documentData.contactsSelectSearch,
  (a) => a
);

export const companiesSelectSearchDataSelector = createSelector(
  (state) => state.documentData.companiesSelectSearch,
  (a) => a
);

export const mergeFieldsSelector = createSelector(
  (state) => state.documentData.mergeFields,
  (a) => a
);

export const documentDataSelector = createSelector(
  (state) => state.documentData?.document,
  (a) => a
);

export const documentNotesDataSelector = createSelector(
  (state) => state.documentData.documentNotes,
  (a) => a
);

export const documentTasksDataSelector = createSelector(
  (state) => state.documentData.documentTasks,
  (a) => a
);

export const documentRevisionsDataSelector = createSelector(
  (state) => state.documentData.documentRevisions,
  (a) => a
);

export const documentProductServicesSelector = createSelector(
  (state) => state.documentData?.document.productServices,
  (a) => a
);

export const documentProductServicesSearchSelector = createSelector(
  (state) => state.documentData?.documentProductServiceSearch,
  (a) => a
);

export const documentOutsourceProductServiceSelector = createSelector(
  (state) => state.documentData?.outsourceProductService,
  (a) => a
);

// SETTINGS

export const documentStatusDataSelector = createSelector(
  (state) => state.documentData.status,
  (a) => a
);

export const documentTypeDataSelector = createSelector(
  (state) => state.documentData.type,
  (a) => a
);

export const documentPaymentTermDataSelector = createSelector(
  (state) => state.documentData.payment_term,
  (a) => a
);

export const documentTenantDataSelector = createSelector(
  (state) => state.documentData.tenantSettings,
  (a) => a
);

// ATTRIBUTES

export const documentsStatusDataSelector = createSelector(
  (state) => state.documentData.status.attributeData,
  (a) => a
);

export const documentsTypesDataSelector = createSelector(
  (state) => state.documentData.type.attributeData,
  (a) => a
);

export const documentsTemplatesDataSelector = createSelector(
  (state) => state.documentData.template.attributeData,
  (a) => a
);

export const documentsAdjustmentsDataSelector = createSelector(
  (state) => state.documentData.adjustment_source.attributeData,
  (a) => a
);

export const documentsProductServiceInventoryDataSelector = createSelector(
  (state) => state.documentData.inventory,
  (a) => a
);

export const documentsDestinationsDataSelector = createSelector(
  (state) => state.documentData.adjustment_destination.attributeData,
  (a) => a
);
export const documentsLocationsDataSelector = createSelector(
  (state) => state.documentData.documentLocations,
  (a) => a
);
export const documentsManufacturersIdsDataSelector = createSelector(
  (state) => state.documentData.documentManufacturerIds,
  (a) => a
);
export const documentsTotalDataSelector = createSelector(
  (state) => state.documentData.documentTotal,
  (a) => a
);
export const _documentsTotalDataSelector = createSelector(
  (state) => state.documentData._documentTotal,
  (a) => a
);

export const allDocumentAttributesDataSelector = createSelector(
  (state) => state.documentData.allDocumentAttributes,
  (a) => a
);
export const selectedSignaturesSelector = createSelector(
  (state) => state.documentData.selectedSignatures,
  (a) => a
);
export const selectedLayoutChange = createSelector(
  (state) => state.documentData.isLayoutChange,
  (a) => a
);

export const documentDraftData = createSelector(
  (state) => state.documentData.draftData,
  (a) => a
);

export const documentTextElementsSelector = createSelector(
  (state) => state.documentData.document.textElements,
  (a) => a
);